import "./App.css";
import { BrowserRouter, Routes, Route, Navigate, useParams } from "react-router-dom";
import { SignupPage } from "./pages/auth/signup";
import { LoginPage } from "./pages/auth/login";
import { AdminLoginPage } from "./pages/auth/admin-login";
import { ParcelPage } from "./pages/content/parcel";
import { ParcelsPage } from "./pages/content/parcels";
import { CartPage } from "./pages/content/cart";
import { HomePage } from "./pages/content/home";
import { TrackParcelPage } from "./pages/content/track_parcel";
import PrivateRoute from "./authorization/private-route.component";
import { jwtDecode } from "jwt-decode";
import AuthService from "./services/auth.service";
import { ProfilePage } from "./pages/content/profile";
import { ResetRequestPage } from "./pages/auth/request-reset-password";
import { ResetPasswordPage } from "./pages/auth/reset-password";
import { AboutPage } from "./pages/content/about";
import { DriverDashBoard } from "./pages/content/driver_dashboard";
import { FAQPage } from "./pages/content/faq";
import { HowItWorksPage } from "./pages/content/how-it-works";
import { ContactPage } from "./pages/content/contact";
import { PaymentSuccessPage } from "./pages/content/payment_success";
import { TermsPage } from "./pages/content/terms";
import { PrivacyPage } from "./pages/content/privacy";
import { DevelopersPage } from "./pages/content/developers";
import MainLayout from "./components/MainLayout";
import BusinessLayout from "./components/business/BusinessLayout";
import BusinessRoute from "./authorization/business-route.component";
import NotBusinessPage from "./pages/business/NotBusinessPage";
import OrdersPage from "./pages/business/OrdersPage";
import CreateOrderPage from "./pages/business/CreateOrderPage";
import BulkUploadPage from "./pages/business/BulkUploadPage";
import TrackPage from "./pages/business/TrackPage";
import SettingsPage from "./pages/business/SettingsPage";

const ReferralRedirect = () => {
  const { code } = useParams();
  return <Navigate to={`/signup?referral_key=${code}`} replace />;
};

function App() {
  const currentUser = AuthService.getCurrentUser();
  if (currentUser) {
    if (jwtDecode(currentUser["token"]).exp < Date.now() / 1000) {
      AuthService.logout();
    }
  }

  return (
    <BrowserRouter>
      <Routes>

        <Route path="/ref/:code" element={<ReferralRedirect />} />

        {/* ── Main site (with site Header + Footer) ── */}
        <Route element={<MainLayout />}>
          <Route path="/"                              element={<HomePage />} />
          <Route path="/home"                          element={<HomePage />} />
          <Route path="/login"                         element={<LoginPage />} />
          <Route path="/admin-login"                    element={<AdminLoginPage />} />
          <Route path="/signup"                        element={<SignupPage />} />
          <Route path="/reset-password"                element={<ResetRequestPage />} />
          <Route path="/auth/reset-password/:reset_token" element={<ResetPasswordPage />} />
          <Route path="/about-us"                      element={<AboutPage />} />
          <Route path="/faq"                           element={<FAQPage />} />
          <Route path="/how-it-works"                  element={<HowItWorksPage />} />
          <Route path="/contact"                       element={<ContactPage />} />
          <Route path="/terms"                         element={<TermsPage />} />
          <Route path="/privacy"                       element={<PrivacyPage />} />
          <Route path="/developers"                    element={<DevelopersPage />} />
          <Route path="/track_parcel"                  element={<TrackParcelPage />} />
          <Route path="/cart"                          element={<CartPage />} />
          <Route path="/payment-success"               element={<PaymentSuccessPage />} />

          <Route element={<PrivateRoute />}>
            <Route path="/profile"                     element={<ProfilePage />} />
            <Route path="/dashboard"                   element={<DriverDashBoard />} />
            <Route path="/parcels"                     element={<ParcelsPage />} />
            <Route path="/parcel/:parcel_id"           element={<ParcelPage />} />
          </Route>
        </Route>

        {/* ── Not a business ── */}
        <Route path="/not-a-business" element={<NotBusinessPage />} />

        {/* ── Business dashboard (own shell, no main Header/Footer) ── */}
        <Route element={<BusinessRoute />}>
          <Route element={<BusinessLayout />}>
            <Route path="/business/dashboard"          element={<OrdersPage />} />
            <Route path="/business/dashboard/create"   element={<CreateOrderPage />} />
            <Route path="/business/dashboard/bulk"     element={<BulkUploadPage />} />
            <Route path="/business/dashboard/track"    element={<TrackPage />} />
            <Route path="/business/dashboard/settings" element={<SettingsPage />} />
          </Route>
        </Route>

      </Routes>
    </BrowserRouter>
  );
}

export default App;
